import * as React from 'react'
import {Box, Typography} from '@mui/material'
import {FONT, SIZE, WEIGHT} from '../../../../styles/foundation/typography'
import {NAVY, SUBTLE, BORDER, SUCCESS, WARNING, ERROR} from '../../../../styles/foundation/colors'
import {EVIDENCE_LEVEL} from '../../shared/evidenceScore'

const ARC = 'M16 100 A84 84 0 0 1 184 100'

export const LEVEL_COLOR = {
  [EVIDENCE_LEVEL.STRONG]: SUCCESS,
  [EVIDENCE_LEVEL.FAIR]: WARNING,
  [EVIDENCE_LEVEL.WEAK]: ERROR,
}

export const LEVEL_WORD = {
  [EVIDENCE_LEVEL.STRONG]: 'Strong evidence',
  [EVIDENCE_LEVEL.FAIR]: 'Fair evidence',
  [EVIDENCE_LEVEL.WEAK]: 'Weak evidence',
}

/**
 * Semicircular arc gauge, drawn with pathLength="100" so strokeDashoffset is
 * literally "100 minus the score" and the arithmetic needs no path-length
 * measurement. MUI's CircularProgress is a full circle and cannot be made a
 * half-arc without overriding its internals.
 *
 * aria-hidden on the svg: the number and the level word beside it are real
 * text, so the arc is decoration and announcing it twice would be noise.
 */
export default function DwsGauge({score, level}) {
  const color = LEVEL_COLOR[level] || ERROR

  return (
    <Box sx={{position: 'relative', width: 164, textAlign: 'center', flexShrink: 0}}>
      <svg viewBox='0 0 200 112' width='164' height='92' aria-hidden='true'>
        <path d={ARC} fill='none' stroke={BORDER} strokeWidth='15' strokeLinecap='round' pathLength='100' />
        <path
          d={ARC}
          fill='none'
          stroke={color}
          strokeWidth='15'
          strokeLinecap='round'
          pathLength='100'
          strokeDasharray='100 100'
          strokeDashoffset={100 - score}
          style={{transition: 'stroke-dashoffset 0.3s, stroke 0.3s'}}
        />
      </svg>
      <Box sx={{position: 'absolute', top: 46, left: 0, right: 0}}>
        <Typography component='span' sx={{fontFamily: FONT, fontWeight: WEIGHT.bold, fontSize: SIZE.lg, color: NAVY, fontVariantNumeric: 'tabular-nums'}}>
          {score}
        </Typography>
        <Typography component='span' sx={{fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE}}>
          /100
        </Typography>
      </Box>
      <Typography sx={{fontFamily: FONT, fontSize: SIZE['2xs'], color: SUBTLE, mt: -1}}>
        Evidence strength
      </Typography>
    </Box>
  )
}
